export const ErrorInterceptor = angular
    .module('checkout.ErrorInterceptor', [])
    .factory('errorInterceptor', ($q, $window, Raven) => {
        return {
            request,
            requestError,
            response,
            responseError
        };

        function request(config) {
            return config;
        }

        function requestError(rejection) {
            Raven.captureMessage('Failed $http request', { extra: rejection });
            return $q.reject(rejection);
        }

        function response(data) {
            return data;
        }

        function responseError(rejection) {
            Raven.captureMessage('Failed $http response', { extra: rejection });
            return $q.reject(rejection);
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/errorInterceptor.js